export default class AnimationScrollPage {
  constructor() {
    this.$el = $('.animation')
    this.winH = window.innerHeight
    this.winW = window.innerWidth
    this.offset = window.innerHeight
    this.WindowScrollTop = null
    this.topCurrent = null
    this.addClassAni = 'set-animation'
  }

  init() {
    this.animationEle()
    $(window).on('scroll resize', () => {
      this.animationEle()
    })
  }

  animationEle() {
    this.offset = this.winH
   // if ($('body').hasClass('has-animation')) {
      this.WindowScrollTop = $(window).scrollTop()
      this.$el.each((_index, ele) => {
        const $elm = $(ele)
        if ($elm.hasClass(this.addClassAni)) {
          return true
        }
        this.topCurrent = $elm.offset().top
        if (this.WindowScrollTop > this.topCurrent - this.offset) {
          $elm.addClass(this.addClassAni)
        }
        return true
      })
  //  }
  }
}

new AnimationScrollPage().init()
